export default {
    list: {
        'search-placeholder': 'Search workspace',
        empty: 'No workspaces yet.',
        'not-found': 'No workspaces found',
        'create-new': 'Create new workspace',
    },
    create: {
        back: 'Go to the list',
        title: 'Create workspace',
        submit: 'Create workspace',
    },
}
